const STORAGE_KEY = "fursatook_visitorCheckoutContact";

export const getVisitorCheckoutContact = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveVisitorCheckoutContact = (contact) => {
  if (!contact) return;
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      firstName: contact.firstName ?? "",
      lastName: contact.lastName ?? "",
      email: contact.email ?? "",
      telephoneNumber: contact.telephoneNumber ?? "",
      nameOnPassport: contact.nameOnPassport ?? "",
      passportExpiresAt: contact.passportExpiresAt ?? null,
    })
  );
};

export const clearVisitorCheckoutContact = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const contactFromBooking = (booking) => {
  if (!booking) return null;
  const hasAny =
    booking.clientFirstName ||
    booking.clientLastName ||
    booking.clientEmail ||
    booking.clientPhone;
  if (!hasAny) return null;

  return {
    firstName: booking.clientFirstName ?? "",
    lastName: booking.clientLastName ?? "",
    email: booking.clientEmail ?? "",
    telephoneNumber: booking.clientPhone ?? "",
    nameOnPassport: booking.clientNameOnPassport ?? "",
    passportExpiresAt: booking.clientPassportExpiresOn ?? null,
  };
};

export const contactFromUser = (user, { includePassport = false } = {}) => {
  if (!user) return null;

  const contact = {
    firstName: user.firstName ?? "",
    lastName: user.lastName ?? "",
    email: user.email ?? "",
    telephoneNumber: user.telephoneNumber ?? "",
    nameOnPassport: "",
    passportExpiresAt: null,
  };

  if (includePassport) {
    contact.nameOnPassport = user.nameOnPassport ?? "";
    contact.passportExpiresAt = user.passportExpiresAt ?? null;
  }

  return contact;
};
